module.exports = __webpack_public_path__ + "static/media/arcs.90ebbff1.png";